import { type Commands } from '../../../core/context/commands';
import { type AssumptionData } from './dto';
import { Assumption } from './entity';
import { Assumptions } from './repository';

export class AssumptionCommands
    implements Commands<Assumptions, Assumption, AssumptionData>
{
    addAll(repo: Assumptions, data: AssumptionData[]): Assumptions {
        data.forEach((assumption) => this.add(repo, assumption));
        return repo;
    }

    add(repo: Assumptions, data: AssumptionData): Assumptions {
        const assumption = new Assumption({ ...data });
        repo.add(assumption);
        return repo;
    }

    update(repo: Assumptions, entity: Assumption): Assumption {
        repo.update(entity);
        return entity;
    }

    remove(repo: Assumptions, id: string): void {
        repo.remove(id);
    }

    create(repo: Assumptions, data: Omit<AssumptionData, 'id'>): Assumption {
        const assumption = Assumption.new(data);
        repo.add(assumption);
        return assumption;
    }

    fromJSON(entity: Assumption[], changeCallback: () => void): Assumptions {
        const assumptions = new Assumptions(changeCallback);
        entity.forEach((assumption) => {
            assumptions.add(new Assumption({ ...assumption }));
        });
        return assumptions;
    }
}
